export default class ListFormatter {
  private s = '';

  public fHead(key, value) {
    this.s += `<h2 class="heading-text">${key}: ${value}</h2>`;
    return this;
  }

  public fSub(key, value) {
    this.s += `<p class="sub1">${key}: ${value}</p>`;
    return this;
  }

  public fSub2(key, value) {
    this.s += `<p class="sub2">${key}: ${value}</p>`;
    return this;
  }

  public fP(s) {
    this.s += `<p class="sub2">${s}</p>`;
    return this;
  }

  public clear() {
    this.s = '';
  }

  public toString() {
    return this.s;
  }
}
